<template>
    <div class="job-ads-main">
        <!-- Tabs -->
        <div class="tabs-bar">
            <button
                class="tab-btn"
                :class="{ active: activeTab === 'ads' }"
                @click="activeTab = 'ads'"
            >
                <i class="material-icons">view_module</i>
                ניהול מודעות
            </button>
            <button
                class="tab-btn"
                :class="{ active: activeTab === 'inbox' }"
                @click="activeTab = 'inbox'"
            >
                <i class="material-icons">inbox</i>
                תיבת פניות
            </button>
        </div>

        <!-- Tab content -->
        <div class="tab-content">
            <AdsList v-if="activeTab === 'ads'" />
            <Inbox v-if="activeTab === 'inbox'" />
        </div>
    </div>
</template>

<script>
import { ref, defineAsyncComponent } from 'vue'

export default {
    name: 'JobAdsMain',
    components: {
        AdsList: defineAsyncComponent(() => import('./components/AdsList.vue')),
        Inbox: defineAsyncComponent(() => import('./components/Inbox.vue'))
    },
    setup() {
        const activeTab = ref('ads')
        return { activeTab }
    }
}
</script>

<style scoped>
.job-ads-main {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #F5F4EF;
    overflow: hidden;
}

/* Tabs */
.tabs-bar {
    display: flex;
    flex-direction: row;
    background: #ffffff;
    border-bottom: 2px solid #e8e8e8;
    padding: 0 16px;
    flex-shrink: 0;
}
.tab-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 14px 20px;
    background: none;
    border: none;
    border-bottom: 3px solid transparent;
    font-size: 14px;
    font-weight: 600;
    color: #888;
    cursor: pointer;
    transition: color 0.2s, border-color 0.2s;
    font-family: inherit;
    margin-bottom: -2px;
}
.tab-btn i {
    font-size: 19px;
}
.tab-btn:hover {
    color: #1579F2;
}
.tab-btn.active {
    color: #1579F2;
    border-bottom-color: #1579F2;
}

/* Content area */
.tab-content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
</style>
